(function ($) {
  const $carouselContainers = $('.paragraph--type--image .field--name-field-images');

  $carouselContainers.each((index, carousel) => {
    const $carousel = $(carousel).addClass('carousel');
    const $images = $carousel.find('.field--type-image');
    const $node = $carousel.closest('.node');
    if ($images.length <= 1) {
      return;
    }
    if ($node.hasClass('node--type-story')){
      if ($images.length <= 3) {
        singleSlider($carousel);
      } else {
        centerSlider($carousel);
      }
    }
    if ($node.hasClass('node--type-article')){
      singleSlider($carousel);
    }
  });

  function addSliderParagraphClass($carousel, $class){
    $carousel.closest('.paragraph--type--image').addClass($class);
  }

  function singleSlider($carousel) {
    addSliderParagraphClass($carousel, 'single-slider');
    $carousel.slick({
      dots: true,
      infinite: true,
      touchThreshold: 100,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      nextArrow: '<button class="slick-next"></button>',
      prevArrow: '<button class="slick-prev"></button>',
    });
  }

  function centerSlider($carousel) {
    addSliderParagraphClass($carousel, 'center-slider');
    $carousel.addClass('center-slider').slick({
      dots: true,
      infinite: true,
      touchThreshold: 100,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      nextArrow: '<button class="slick-next"></button>',
      prevArrow: '<button class="slick-prev"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
})(jQuery);
